import React from "react";
import {
  Button,
  Col,
  Divider,
  Flex,
  Gap,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../ppui";
// import { MdCurrencyRupee } from "react-icons/md";

const BeneficiaryInfo = () => {
  return (
    <>
      <Flex justifyContent="space-between" gap={10} mb={18}>
        <Typography variant="h5" mb={"0"}>
          Nominee Details
        </Typography>
        <Button onClick={() => {}} variant="outlined" size="sm">
          Add More
        </Button>
      </Flex>

      <Row rowGap>
        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            type="text"
            fullWidth
            label="Nominee Name"
            placeholder="Type Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <SelectField
            fullWidth
            label="Nominee Relation"
            options={[
              { id: "Spouse", name: "Spouse" },
              { id: "Child", name: "Child" },
              { id: "Parent", name: "Parent" },
              { id: "Sibling", name: "Sibling" },
              { id: "Grandparent", name: "Grandparent" },
              { id: "Grandchild", name: "Grandchild" },
              { id: "Guardian", name: "Guardian" },
              { id: "Relative", name: "Relative" },
              { id: "Friend", name: "Friend" },
            ]}
            placeholder="Select Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            fullWidth
            type="date"
            label="DOB"
            placeholder="Select Here..."
            valueSinc
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            type="number"
            fullWidth
            label="Contact Number"
            placeholder="Type Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            fullWidth
            type="text"
            label="Address"
            placeholder="Type Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            fullWidth
            type="number"
            label="Percentage of Benefits"
            placeholder="Type Here..."
            prefix={"%"}
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            fullWidth
            type="file"
            label="ID Proof"
            valueSinc
            placeholder="Type Here..."
          />
        </Col>
      </Row>

      <Divider gap={20} />

      <Typography variant="h5">Bank Details</Typography>

      <Row rowGap>
        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            type="text"
            fullWidth
            label="Bank Name"
            placeholder="Type Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            fullWidth
            type="number"
            label="Account Number"
            placeholder="Type Here..."
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            type="text"
            fullWidth
            label="IFSC Code"
            placeholder="Type Here..."
          />
        </Col>

      </Row>

      <Gap height={100} />

      <Flex justifyContent="flex-end" gap={"10"}>
        <Button onClick={() => {}} variant="outlined">
          Cancel
        </Button>
        <Button color="primary" onClick={() => {}} variant="outlined">
          Save & Exit
        </Button>
        <Button color="primary" onClick={() => {}} variant="contained">
          Next
        </Button>
      </Flex>
    </>
  );
};

export default BeneficiaryInfo;
